import { render, staticRenderFns } from "./full-movie-card.vue?vue&type=template&id=02b16b9a&scoped=true&"
import script from "./full-movie-card.vue?vue&type=script&lang=ts&"
export * from "./full-movie-card.vue?vue&type=script&lang=ts&"
import style0 from "./full-movie-card.vue?vue&type=style&index=0&id=02b16b9a&prod&lang=scss&"
import style1 from "./full-movie-card.vue?vue&type=style&index=1&id=02b16b9a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b16b9a",
  null
  
)

export default component.exports